<template>

    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="type === 0 ? $i18n.t('product.text107') : $i18n.t('product.text108')"
        :visible.sync="visible"
        width="35%"
        @close="closeDialog"
        @open="openDialog">

        <el-form :model="form" size="small" :rules="rules" ref="ruleForm" class="effect_form"
                 :label-width="formLabelWidth" v-if="type === 0">

            <el-form-item :label="$i18n.t('product.text34')+'：'" prop="effectName">
                <el-input
                    v-model.trim="form.effectName"
                    :placeholder="$i18n.t('product.text59')">
                </el-input>
            </el-form-item>

            <el-form-item :label="$i18n.t('product.text35')+'：'" prop="effectRemarks">
                <el-input
                    v-model.trim="form.effectRemarks"
                    :disabled="form.effectType === 1"
                    :placeholder="$i18n.t('product.text60')">
                </el-input>
            </el-form-item>

            <el-form-item :label="$i18n.t('product.text40')+'：'" prop="authority">
                <el-radio-group v-model="form.authority" :disabled="form.effectType === 1">
                    <el-radio :label="item1.id" v-for="(item1,index1) in $message.authorityList" :key="index1">
                        {{ item1.name }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item :label="$i18n.t('product.text6')">
                <el-input
                    type="textarea"
                    :disabled="form.effectType === 1"
                    v-model="form.remark"
                    :rows="4"
                    show-word-limit
                    maxlength="200"
                    :placeholder="$i18n.t('product.text61')">
                </el-input>
            </el-form-item>

        </el-form>

        <el-form :model="form" size="small" :rules="rules" ref="ruleForm" class="effect_form"
                 :label-width="formLabelWidth" v-else>
            <el-form-item :label="$i18n.t('product.text34')+'：'">{{ form.effectName }}</el-form-item>
            <el-form-item :label="$i18n.t('product.text35')+'：'">{{ form.effectRemarks }}</el-form-item>
            <el-form-item :label="$i18n.t('product.text40')+'：'">{{ $config.getMsgItemUtil($message.authorityList, form.authority, 'id', 'name') }}</el-form-item>
            <el-form-item :label="$i18n.t('product.text6')">{{ form.remark }}</el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">{{$i18n.t('product.text63')}}</el-button>
            <el-button type="primary" :loading="loading" @click="submit" v-if="type === 0">{{$i18n.t('product.text105')}}</el-button>
        </span>

    </el-dialog>

</template>

<script>

import {mapState, mapActions} from "vuex";

export default {

    computed: {
        ...mapState('effect', ['modifyEffectDialogVisible', 'effectListItem', 'effectDialogType'])
    },

    watch: {

        modifyEffectDialogVisible: {
            handler(newVal) {
                this.visible = newVal;
            }
        },

        effectListItem: {
            handler(newVal) {
                this.form = {
                    code: newVal.code,
                    effectName: newVal.effectName,
                    effectRemarks: newVal.effectRemarks,
                    effectType: newVal.effectType,
                    authority: newVal.authority,
                    remark: newVal.remark
                }
            },
            deep: true
        },

        effectDialogType: {
            handler(newVal) {
                this.type = newVal;
            }
        }

    },

    data() {

        return {

            formLabelWidth: "100px",

            visible: false,

            loading: false,

            type: 0,

            form: {
                code: "",
                effectName: "",
                effectRemarks: "",
                remark: "",
                authority: ""
            },

            rules: {
                effectName: [
                    {required: true, message: this.$i18n.t('product.text59'), trigger: "blur"},
                    {pattern: /^(?=[\S\s]{1,20}$)[\S\s]*/, message: this.$i18n.t('product.text23')},
                ],
                authority: [{required: true, message: this.$i18n.t('product.text67'), trigger: "blur"}],
                effectRemarks: [
                    {required: true, message: this.$i18n.t('product.text60'), trigger: "blur"},
                    {pattern: /^(?=[\S\s]{1,32}$)[\S\s]*/, message: this.$i18n.t('product.text68')},
                    {pattern: /^[a-z_0-9]*$/, message: this.$i18n.t('product.text17')},
                ],
            },
            language: localStorage.getItem('language')

        }

    },

    methods: {

        ...mapActions('effect', ['modifyProductService', 'closeModifyEffectDialog']),

        closeDialog() {
            this.closeModifyEffectDialog();
            this.$refs['ruleForm'].resetFields();
        },

        openDialog() {
            this.type = this.effectDialogType;
            this.formLabelWidth = this.language === 'zh' ? '100px' : '180px'
        },

        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.modifyProductService({
                        authority: this.form.authority,
                        name: this.form.effectName,
                        serviceCode: this.form.code,
                        serviceKey: this.form.effectRemarks,
                        productCode: this.$route.query.id,
                        remark: this.form.remark
                    }).then(res => {
                        this.loading = false;
                        this.$dialog.showMessage(this.$i18n.t('product.text25'), this.$config.TOAST_SUCCESS);
                        this.$emit("getMsg");
                        this.closeDialog();
                    }, err => {
                        this.loading = false;
                        this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
                    })
                }
            })
        }

    }

}

</script>

<style scoped>

.effect_form {
    margin-top: 20px;
}

/deep/ .el-dialog {
    text-align: left !important;
}

/deep/ .el-dialog--center .el-dialog__footer {
    text-align: right !important;
}

/deep/ .el-dialog__body {
    padding-top: 0;
}

/deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
}

/deep/ .el-dialog__header {
    border-bottom: 1px solid #E9E9E9;
    padding: 13px;
}
</style>
